import React, { useState, useEffect } from "react";

const BucketLogo = () => {
  const [sparks, setSparks] = useState([]);

  useEffect(() => {
    let count = 0;
    let interval;
    let resetTimeout;

    const spawnSparks = () => {
      interval = setInterval(() => {
        count++;
        const id = Date.now() + Math.random();
        const left = Math.random() * 20 + 40; // 40%-60% cluster under bucket
        const delay = Math.random() * 0.3;

        setSparks((prev) => [...prev, { id, left, delay }]);

        if (count >= 15) { // reduced number of sparks
          clearInterval(interval);
          resetTimeout = setTimeout(() => {
            setSparks([]);
            count = 0;
            spawnSparks();
          }, 3000);
        }
      }, 350);
    };

    spawnSparks();
    return () => {
      clearInterval(interval);
      clearTimeout(resetTimeout);
    };
  }, []);

  return (
    <div className="logo-container">
      {/* Bucket SVG with embedded gold gradient */}
      <svg
        width="80"
        height="80"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        className="bucket"
      >
        <defs>
          <linearGradient id="gold-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FFD700" />
            <stop offset="100%" stopColor="#B8860B" />
          </linearGradient>
        </defs>
        <g transform="rotate(-25,32,32)">
          <rect x="20" y="15" width="24" height="34" rx="6" fill="url(#gold-gradient)" />
          <path d="M20 15 L44 15 L40 5 L24 5 Z" fill="url(#gold-gradient)" />
        </g>
      </svg>

      {/* Sparks */}
      <div className="sparks">
        {sparks.map((spark) => (
          <div
            key={spark.id}
            className="spark"
            style={{
              left: `${spark.left}%`,
              animationDelay: `${spark.delay}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default BucketLogo;